import { UilBuilding, UilUsersAlt } from "@iconscout/react-unicons";
import styled from "styled-components";

const OuterBorder = styled.div<{ $variant: TVariants; $maxWidth?: string }>`
  transition: border-color 0.2s;

  border: 2px solid transparent;
  border-radius: 18px;

  &:active {
    ${({ $variant }) =>
      $variant === "orgs"
        ? `border-color: var(--color-main-rose);`
        : `border-color: var(--color-main-blue);`}
  }
`;

const Container = styled.button<{ $variant: TVariants; $maxWidth?: string }>`
  width: calc(548vw / 14.4);
  max-width: ${({ $maxWidth }) => $maxWidth || "550px"};
  height: 146px;

  margin: 2px;

  @media (min-width: 1441px) {
    max-width: 550px;
  }

  cursor: pointer;

  overflow: hidden;

  position: relative;

  border-radius: 16px;
  border: 1px solid var(--color-dark-blue-300);

  background: var(--color-light-0);

  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);

  p.title {
    transition: color 0.2s;
  }

  &:hover {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(254, 49, 113, 0.05) 100%
    );
  }

  p {
    margin-left: 24px;
    text-align: left;
  }

  p.title {
    font-family: var(--font-title-bold);
    font-size: 18px;
    color: var(--color-text-title);
  }

  p.description {
    font-family: var(--font-paragraph-default);
    font-size: 12px;
    color: var(--color-dark-blue-400);
  }

  svg {
    position: absolute;

    ${({ $variant }) =>
      $variant === "orgs"
        ? `fill: var(--color-light-200);` +
          ` height: 150px;` +
          ` width: 150px;` +
          `top: 20px;` +
          `right: -40px;`
        : `fill: var(--color-light-200);` +
          ` height: 150px;` +
          ` width: 150px;` +
          `top: 20px;` +
          `right: -40px;`};
  }

  &:hover,
  &:active {
    p.title {
      color: ${({ $variant }) =>
        $variant === "orgs"
          ? `var(--color-main-rose)`
          : `var(--color-main-blue)`};
    }

    svg {
      ${({ $variant }) =>
        $variant === "orgs"
          ? `fill: var(--color-main-rose);`
          : `fill: var(--color-main-blue);`}
    }
  }
`;

type TVariants = "orgs" | "users";

type TExtraLargeButtonProps = {
  variant: TVariants;
  maxWidth?: string;
  onClick: () => void;
};

const ExtraLargeButton: React.FC<TExtraLargeButtonProps> = ({
  variant,
  onClick,
  maxWidth,
}) => {
  const handleVariant = () => {
    switch (variant) {
      case "orgs":
        return (
          <>
            <p className="title">Gerenciar organizações</p>
            <p className="description">Suas unidades de negócio no Portal</p>
            <UilBuilding />
          </>
        );
      case "users":
        return (
          <>
            <p className="title">Gerenciar usuários</p>
            <p className="description">Usuários que têm acesso ao Portal</p>
            <UilUsersAlt />
          </>
        );
    }
  };

  return (
    <OuterBorder $variant={variant}>
      <Container
        $maxWidth={maxWidth}
        type="button"
        onClick={onClick}
        $variant={variant}
      >
        {handleVariant()}
      </Container>
    </OuterBorder>
  );
};

export default ExtraLargeButton;
